import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Image, Ref } from 'semantic-ui-react';
import spotifyIcon from '../../../assets/spotify_icon_green.svg';
import axios from 'axios';
import { Wizard, GlobalNotifications, Intent } from '../../Modules';
import SelectPlaylist from './SelectPlaylist';
import SelectSongs from './SelectSongs';

class ImportPlaylist extends Component {
  static propTypes = {
    addToPlaylist: PropTypes.func.isRequired,
    importSpotifyRef: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      selectPlaylistOpen: false
    };
    this.getPlaylists = this.getPlaylists.bind(this);
    this.authenticateSpotify = this.authenticateSpotify.bind(this);
    this.browseSpotifyPlaylists = this.browseSpotifyPlaylists.bind(this);
  }

  getPlaylists({ limit = 50, offset = 0, playlists = [] }) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('spotify_access_token')}`
      },
      params: { limit, offset }
    };
    axios
      .get('https://api.spotify.com/v1/me/playlists', config)
      .then(response => {
        if (response.data.next) {
          this.getPlaylists({
            limit,
            offset: offset + limit,
            playlists: playlists.concat(response.data.items)
          });
        } else {
          this.setState({
            spotifyPlaylists: playlists.concat(response.data.items),
            selectPlaylistOpen: true
          });
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.authenticateSpotify(() => this.getPlaylists({}));
        } else {
          GlobalNotifications.show({
            message: 'Unable to connect to Spotify',
            intent: Intent.DANGER
          });
        }
      });
  }

  authenticateSpotify(onSuccess, onError) {
    localStorage.removeItem('spotify_access_token');
    const spotifyAuth = window.open(
      `https://accounts.spotify.com/en/authorize?client_id=${process.env
        .SPOTIFY_CLIENT_ID}&redirect_uri=${encodeURIComponent(
        process.env.BASE_URL
      )}%2Fspotify&scope=playlist-read-private+playlist-read-collaborative&response_type=token&show_dialog=true`
    );
    const timer = setInterval(() => {
      if (spotifyAuth.closed) {
        clearInterval(timer);
        if (localStorage.getItem('spotify_access_token')) {
          if (onSuccess) onSuccess();
        } else {
          if (onError) onError();
        }
      }
    }, 1000);
  }

  browseSpotifyPlaylists() {
    this.getPlaylists({});
  }

  render() {
    const {
      spotifyPlaylists,
      selectPlaylistOpen,
      selectedPlaylistId
    } = this.state;
    const { addToPlaylist, importSpotifyRef } = this.props;
    const title = 'Import Playlist from Spotify';
    return (
      <div>
        <Dropdown
          button
          basic
          icon='plus'
          compact
          className='icon selection'
          floating
          style={{ padding: '0.75em' }}
        >
          <Dropdown.Menu style={{ left: 'auto', right: 0, width: 'auto' }}>
            <Dropdown.Header content='Import From' />
            <Ref innerRef={importSpotifyRef}>
              <Dropdown.Item onClick={this.browseSpotifyPlaylists}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Image style={{ marginRight: '0.5em' }} src={spotifyIcon} />
                  Spotify
                </div>
              </Dropdown.Item>
            </Ref>
            {/* <Dropdown.Divider /> */}
            {/* <Dropdown.Item>Add Custom Song</Dropdown.Item> */}
          </Dropdown.Menu>
        </Dropdown>
        <Wizard
          steps={[
            {
              component: SelectPlaylist,
              componentProps: {
                playlists: spotifyPlaylists || [],
                selectedPlaylistId,
                onPlaylistSelect: id =>
                  this.setState({ selectedPlaylistId: id })
              },
              hideActions: true,
              title
            },
            {
              component: SelectSongs,
              componentProps: {
                addToPlaylist,
                selectedPlaylistId,
                authenticateSpotify: this.authenticateSpotify
              },
              hideActions: true,
              title
            }
          ]}
          open={selectPlaylistOpen}
          onClose={() =>
            this.setState({
              selectPlaylistOpen: false,
              selectedPlaylistId: null
            })}
        />
      </div>
    );
  }
}

export default ImportPlaylist;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Import/index.js